import { useState } from "react";

const faqs = [
  {
    question: "How do I request a personalized consultation?",
    answer:
      "If you need proper and affordable coverage, you can request a consultation directly through our website or by contacting us at 805-692-6900 or support@paladinbusinessservices.net. One of our licensed agents will work with you to craft a personalized insurance plan that fits your specific needs.",
  },
  {
    question: "How do I request proof of insurance?",
    answer:
      "You can submit a proof of insurance request through our website. One of our licensed agents will send it out to you as soon as possible. For urgent requests, you may also call us directly at 805-692-6900 during business hours.",
  },
  {
    question: "How do I make changes to my existing policy?",
    answer:
      "Policy changes are easy to request. Simply submit your change request through our website or contact our office and we will update your policy accordingly. Our agents are available Monday through Friday, 9:00 AM – 5:00 PM, to assist with any modifications.",
  },
  {
    question: "How do I update my contact information on file?",
    answer:
      "To update your contact details on an existing policy, you can submit a request through our website or reach out to us directly by phone or email. Our team will process the update promptly to ensure your records stay current.",
  },
  {
    question: "How do I report a claim?",
    answer:
      "You can report a claim through our website or by contacting our office. Once your claim is submitted, one of our licensed agents will reach out to you shortly to provide personalized support and guidance throughout the entire claims process.",
  },
  {
    question: "Can I request a call from a Paladin agent?",
    answer:
      "Yes. If you need further assistance or simply prefer to speak with someone, you can request a call through our website. One of our licensed agents will reach out to you promptly to address your questions or concerns.",
  },
];

function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div
      className={`border transition-all duration-200 overflow-hidden ${
        isOpen
          ? "border-blue-dark border-opacity-25 bg-white-pure shadow-sm"
          : "border-blue-dark border-opacity-8 bg-white-warm hover:bg-white-pure hover:border-opacity-18"
      }`}
      style={{ borderRadius: "16px" }}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-7 py-5 text-left group"
        aria-expanded={isOpen}
      >
        <span
          className={`font-constantia font-bold pr-5 transition-colors duration-150 ${
            isOpen ? "text-blue-dark" : "text-blue-dark opacity-75 group-hover:opacity-100"
          }`}
          style={{ fontSize: "15.5px", lineHeight: "1.45" }}
        >
          {question}
        </span>

        <span
          className={`flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center transition-all duration-250 ${
            isOpen
              ? "bg-blue-dark border-blue-dark text-white-pure"
              : "border-blue-dark border-opacity-20 text-blue-dark group-hover:border-opacity-40"
          }`}
          style={{
            fontSize: "17px",
            lineHeight: 1,
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.25s ease, background 0.2s, border-color 0.2s",
          }}
          aria-hidden="true"
        >
          +
        </span>
      </button>

      <div
        style={{
          display: "grid",
          gridTemplateRows: isOpen ? "1fr" : "0fr",
          transition: "grid-template-rows 0.28s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div className="px-7 pb-6">
            <div className="h-px bg-blue-dark opacity-8 mb-4" />
            <p
              className="font-constantia text-black-deep opacity-60 leading-relaxed"
              style={{ fontSize: "15px" }}
            >
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ConsultationsFaqsSection({ searchQuery = "" }) {
  const [openIndex, setOpenIndex] = useState(null);

  const filtered = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (filtered.length === 0) return null;

  return (
    <section id="consultations" className="bg-white-pure w-full py-16 px-6">
      <div className="max-w-3xl mx-auto">

        <div className="flex items-center gap-3 mb-8">
          <div
            className="bg-blue-dark opacity-50 rounded-full"
            style={{ width: "2px", height: "20px" }}
          />
          <span
            className="font-cinzel text-blue-dark uppercase"
            style={{ fontSize: "10px", letterSpacing: "0.22em" }}
          >
            Consultations &amp; Requests
          </span>
          {searchQuery && (
            <span
              className="ml-auto font-constantia text-blue-dark opacity-35"
              style={{ fontSize: "11px" }}
            >
              {filtered.length} result{filtered.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-3">
          {filtered.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}